<!--<p-card>-->
<!--  <p-tabMenu [model]="typeCatalogue" [activeItem]="activeItem"></p-tabMenu>-->
<!--  <p-card>-->
    <router-outlet></router-outlet>
<!--  </p-card>-->
<!--</p-card>-->
